import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapAbstract } from './map.abstract';
import {
  GoogleMap,
  MapAdvancedMarker,
  MapCircle,
  MapInfoWindow,
  MapMarker,
  MapMarkerClusterer,
  MapPolygon,
  MapPolyline,
} from '@angular/google-maps';
import { LegendPathComponent } from '../legend-path/legend-path.component';
import { PathPlayerComponent } from '../path-player/path-player.component';
import { ActionEvent } from '@infodata-group/inf-commons';
import { DetailsComponent } from '@infodata-group/inf-commons-desktop';

@Component({
  selector: 'ao-shared-map',
  imports: [
    CommonModule,
    GoogleMap,
    MapPolyline,
    MapMarker,
    LegendPathComponent,
    PathPlayerComponent,
    MapAdvancedMarker,
    MapCircle,
    MapPolygon,
    MapMarkerClusterer,
    DetailsComponent,
    MapInfoWindow,
  ],
  templateUrl: './map.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './map.component.scss',
})
export class MapComponent extends MapAbstract {
  public showLegend = input<boolean>(false);
  public showPlayer = input<boolean>(false);

  public currentHeight = computed(() => {
    let height = `calc(${this.height()}`;
    if (this.showLegend() && this.aoPath()) {
      height += ' - 25px';
    }
    if (this.showPlayer() && this.aoPath()) {
      height += ' - 40px';
    }
    if (this.showLegend() && this.showPlayer() && this.aoPath()) {
      height += ' - 1px'; // Border
    }
    height += ')';
    return height;
  });

  public onPlayEvent($event: ActionEvent): void {
    this.aoPath().currentIndex = $event.value;
  }
}
